import * as React from 'react';
import UserLookup from '../../common/form-controls/UserLookup';
import FieldHandler from '../../../models/interfaces/FieldHandler';

interface ApproverInputProps extends FieldHandler<string> {
	higherApproval: boolean;
	scope?: string;
}

interface ApproverInputState {}

export class ApproverInput extends React.Component<ApproverInputProps, ApproverInputState> {
	doagLevel = () => {
		const level = (this.props.higherApproval ? 6 : 8);
		
		return level;
	};

	render() {
		return (
			<UserLookup
				label={`Approver (DOAG ${this.doagLevel().toString()})`}
				isEmployee
				note='Select your functional management’s authority'
				{...this.props}
			/>
		);
	}
}
